import { useTranslation } from "react-i18next";
import { CalendarOff } from "lucide-react";

// يوم عطلة والدوام غير مسموح: نفس أسلوب شاشة الغياب — رسالة واضحة بدل كاميرا مقفلة.
export const OffDayNotice = ({ check, onClose }) => {
  const { t } = useTranslation();
  const holiday = check?.holiday;
  const isHoliday = check?.day_type === "holiday";

  return (
    <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-4 py-6 text-center"
      data-testid="off-day-notice">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-sky-500/15 shadow-neu-in">
        <CalendarOff className="h-9 w-9 text-sky-500" />
      </span>
      <div>
        <p className="text-xl font-black text-sky-500" data-testid="off-day-notice-title">
          {isHoliday ? t("offDay.holidayTitle", { name: holiday || "" }) : t("offDay.weekendTitle")}
        </p>
        <p className="mx-auto mt-2 max-w-xs text-sm font-semibold text-muted-foreground">
          {t("offDay.reason")}
        </p>
      </div>
      <p className="max-w-xs text-xs text-muted-foreground">{t("offDay.hint")}</p>
      <button
        type="button"
        data-testid="off-day-notice-close"
        onClick={onClose}
        className="rounded-2xl bg-primary px-6 py-3 text-sm font-bold text-primary-foreground"
      >
        {t("app.close")}
      </button>
    </div>
  );
};
